import {atom} from "jotai";

/**
 * Atoms with React Router URL Path parameters
 */

export const routerCompanyIdAtom = atom<string | undefined>(undefined);

export const routerUserIdAtom = atom<string | undefined>(undefined);

export const routerFarmIdAtom = atom<string | undefined>(undefined);

export const routerFieldIdAtom = atom<string | undefined>(undefined);

export const routerOrderIdAtom = atom<string | undefined>(undefined);

routerFieldIdAtom.debugLabel = "activeRouterFieldAtom";
routerFarmIdAtom.debugLabel = "activeRouterFarmAtom";
